module.exports = __webpack_public_path__ + "img/13.3d98d4e3.png";